<template>
  <vk-modal @close="$emit('close')">
    <vk-modal-body>
      <vk-modal-header class="text-bold">
        Cancel this request?
      </vk-modal-header>
      <vk-modal-content>
        <div selenium="cancel-request-copy" class="h6 m-b-2">
          You will not be able to get more quotes for this request if you cancel it.<br>
          Please let us know why, so we can better serve you next time.
        </div>
        <div v-for="(reason, key, index) in cancelReasons" :key="key" class="radio d-block m-b-1">
          <input
              :disabled="canceling"
              :id="key"
              :value="key"
              v-model="selectedReason"
              type="radio"
              name="cancel_reason">
          <label :for="key" :selenium="`cancel-reason-radio-selection:${index+1}`">
            {{ reason }}
          </label>
        </div>
        <textarea
            :disabled="canceling"
            v-model="otherReason"
            maxlength="1024"
            class="textarea input"
            name="other"
            rows="6"
            cols="20"
            selenium="modal-textarea"
            @focus="selectOther"/>
      </vk-modal-content>
      <vk-modal-footer class="d-flex jc-end ai-center fd-column:mo">
        <button
            :disabled="!isCancelable || canceling"
            class="btn-tertiary w-100:mo m-r-2:t m-b-2:mo"
            @click="cancelRequest">
          Yes, cancel this request
        </button>
        <button
            :disabled="canceling"
            selenium="keep-request-button"
            class="btn w-100:mo"
            @click="$emit('close')">
          Keep this request
        </button>
      </vk-modal-footer>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
const OTHER_OPTION_KEY = 'other';
const CANCEL_REASONS = {
  booked: 'Already booked one of the Pro Referral professionals',
  outside: 'Found a different professional outside of Pro Referral',
  price: 'Prices were too high',
  quality: 'Professional\'s profiles weren\'t good enough',
  change: 'Changed my mind, not going to do get the job done at all',
  [OTHER_OPTION_KEY]: 'Something else? Please explain below:',
};

export default {
  name: 'cancel-request-modal',
  props: {
    canceling: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      cancelReasons: CANCEL_REASONS,
      selectedReason: null,
      otherReason: '',
    };
  },
  computed: {
    isOtherSelected () {
      return this.selectedReason === OTHER_OPTION_KEY;
    },
    isCancelable () {
      return this.isOtherSelected ? this.otherReason.trim() : this.selectedReason;
    },
  },
  methods: {
    selectOther () {
      this.selectedReason = OTHER_OPTION_KEY;
    },
    cancelRequest () {
      let payload = this.cancelReasons[this.selectedReason];

      if (this.isOtherSelected) {
        payload = `${payload} ${this.otherReason}`;
      }

      this.$emit('cancelRequest', payload);
      this.$events.$emit(this.$events.CONSUMER_CANCEL_REQUEST, { reason: payload });
    },
  },
};
</script>
